"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const OffsetMargin = Theme_1.styled.div `
  margin-right: -13px;
`;
const TriangleCornerTop = Theme_1.styled.div `
  border-top: 16px solid
    ${(props) => (props.color && props.theme[props.color]) || props.color};
  background-color: transparent;
  border-right: 20px solid transparent;
  transform: ${(props) => props.orientation === 'left' ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
const LastSegment = Theme_1.styled.div `
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  flex: 1;
  background-color: ${(props) => (props.color && props.theme[props.color]) || props.color};
`;
const MiddleSegment = Theme_1.styled.div `
  flex: 1;
  background-color: ${(props) => (props.color && props.theme[props.color]) || props.color};
`;
const FirstSegment = Theme_1.styled.div `
  flex: 1;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  background-color: ${(props) => (props.color && props.theme[props.color]) || props.color};
`;
const StatusBarSegments = Theme_1.styled.div `
  display: flex;
  flex-direction: row;
  height: 16px;
`;
const StatusBarContainer = Theme_1.styled.div `
  margin: 8px 0px;
`;
const getStatusBarSegments = (currentStep = 0, stepColor = 'green', stepTotal = 3) => {
    const segments = [];
    for (let i = 1; i <= stepTotal; i++) {
        const segmentColor = i <= currentStep ? stepColor : 'gray4';
        const segment = i == 1 ? (react_1.default.createElement(react_1.default.Fragment, { key: i },
            react_1.default.createElement(FirstSegment, { "data-testid": "step", color: segmentColor }),
            react_1.default.createElement(TriangleCornerTop, { color: segmentColor }))) : i == stepTotal ? (react_1.default.createElement(react_1.default.Fragment, { key: i },
            react_1.default.createElement(OffsetMargin, null),
            react_1.default.createElement(TriangleCornerTop, { color: segmentColor, orientation: "left" }),
            react_1.default.createElement(LastSegment, { "data-testid": "step", color: segmentColor }))) : (react_1.default.createElement(react_1.default.Fragment, { key: i },
            react_1.default.createElement(OffsetMargin, null),
            react_1.default.createElement(TriangleCornerTop, { color: segmentColor, orientation: "left" }),
            react_1.default.createElement(MiddleSegment, { "data-testid": "step", color: segmentColor }),
            react_1.default.createElement(TriangleCornerTop, { color: segmentColor })));
        segments.push(segment);
    }
    return segments;
};
const Stepper = (props) => {
    return (react_1.default.createElement(StatusBarContainer, null,
        react_1.default.createElement(StatusBarSegments, null, getStatusBarSegments(props.currentStep, props.stepColor, props.stepTotal))));
};
exports.Stepper = Stepper;
//# sourceMappingURL=Stepper.js.map